// extracted by css-extract-rspack-plugin
export default {"viewed":"MarkAsViewedButton-module__viewed__VcCRFcJ","iconOnly":"MarkAsViewedButton-module__iconOnly__JUtuioh"};